/* eslint-disable */

var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;


Vue.config.ignoredElements = [/^ion-/]
import 'custom-event-polyfill';
// import '@babel/polyfill';
// My own polyfill
// https://stackoverflow.com/questions/4313841/insert-a-string-at-a-specific-index
if (!String.prototype.splice) {
	/**
	 * {JSDoc}
	 *
	 * The splice() method changes the content of a string by removing a range of
	 * characters and/or adding new characters.
	 *
	 * @this {String}
	 * @param {number} start Index at which to start changing the string.
	 * @param {number} delCount An integer indicating the number of old chars to remove.
	 * @param {string} newSubStr The String that is spliced in.
	 * @return {string} A new string with the spliced substring.
	 */
	String.prototype.splice = function(start, delCount, newSubStr) {
		return this.slice(0, start) + newSubStr + this.slice(start + Math.abs(delCount));
	};
}

// Object.values

var objectToValuesPolyfill = function(object) {
	return Object
		.keys(object)
		.map(
			function(key) {
				return object[key];
			}
		);
}

Object.values = Object.values || objectToValuesPolyfill;



// Object.entries

var objectToEntriesPolyfill = function(object) {
	return Object
		.keys(object)
		.map(
			function(key) {
				return [key, object[key]];
			}
		);
}

Object.entries = Object.entries || objectToEntriesPolyfill;



import Vue from 'vue'

import VueKeepScrollPosition from 'vue-keep-scroll-position'
Vue.use(VueKeepScrollPosition);

import LiquorTree from 'liquor-tree'

// global registration
Vue.use(LiquorTree)
import App from './App.vue'
// import './registerServiceWorker'
import Autocomplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

// const __svg__ = {
// 	path: './assets/images/icons/*.svg',
// 	name: 'assets/images/[hash].sprite.svg'
// }
// svgSpriteLoader(__svg__.filename)

import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

// register globally
Vue.component('multiselect', Multiselect)

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
const toastOptions = {};
Vue.use(Toast, toastOptions);

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
Vue.component('treeselect', Treeselect);

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask);


import VueGeolocation from 'vue-browser-geolocation';
Vue.use(VueGeolocation);

import LoadScript from 'vue-plugin-load-script';
Vue.use(LoadScript);

// import VuePassword from './components/vue-password'
// Vue.component(
// 	VuePassword
// );

// import wysiwyg from "./components/vue-wysiwyg";
// import "./components/vue-wysiwyg/vueWysiwyg.css";

import wysiwyg from "./components/vue-wysiwyg";
import "./components/vue-wysiwyg/vueWysiwyg.css";

var hideIE11 = false;
if (isIE11) {
	hideIE11 = true;
}
Vue.use(wysiwyg, {
	hideModules: {
		"justifyLeft": true,
		"justifyCenter": true,
		"justifyRight": true,
		"table": true,
		"separator": true,
		"headings": hideIE11,
		"code": true,
		"image": true,
	}
}); // config is optional. more below


// import { Icon } from 'leaflet'
// import 'leaflet/dist/leaflet.css'

import DeepDiff from 'deep-diff';
Vue.use(DeepDiff);

// Vue.component('l-map', LMap);
// Vue.component('l-tile-layer', LTileLayer);
// Vue.component('l-marker', LMarker);




import vSelect from 'vue-select'
// import "vue-select/src/scss/vue-select.scss";
import 'vue-select/dist/vue-select.css';
Vue.component('v-select', vSelect)

import VueTimeago from 'vue-timeago'

Vue.use(VueTimeago, {
	name: 'Timeago', // Component name, `Timeago` by default
	locale: 'en', // Default locale
})


// import VueFormWizard from 'vue-form-wizard'
// import 'vue-form-wizard/dist/vue-form-wizard.min.css'

import VueFormWizard from './components/vue-form-wizard'
import './components/vue-form-wizard/assets/wizard.scss'
Vue.use(VueFormWizard)

// delete Icon.Default.prototype._getIconUrl;

// Icon.Default.mergeOptions({
//   iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
//   iconUrl: require('leaflet/dist/images/marker-icon.png'),
//   shadowUrl: require('leaflet/dist/images/marker-shadow.png')
// });

import Paginate from 'vuejs-paginate'
Vue.component('paginate', Paginate);

import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
Vue.component('date-range-picker', DateRangePicker);


// import DateRangePicker from './components/vue2-daterange-picker/src/index.js';
// import './components/vue2-daterange-picker/dist/vue2-daterange-picker.css'
// Vue.component('date-range-picker', DateRangePicker);


// used to convert kml to geojson?
Vue.loadScript("/js/ZipFile.complete.js", "ZipFile").then(() => {
		// Script is loaded, do something
		Vue.prototype.$ZipFile = ZipFile;

	})
	.catch(() => {});

// Vue.loadScript("/js/leaflet-kml/L.KML.js");
// import {LMap, LTileLayer, LMarker} from 'vue2-leaflet'

// import * as VueGoogleMaps from 'vue2-google-maps'
import * as GmapVue from 'gmap-vue'

Vue.prototype.$googleApiKey = process.env.VUE_APP_GOOGLE_API_KEY

Vue.use(GmapVue , {
	load: {
		key: Vue.prototype.$googleApiKey,
		// libraries: 'drawing,visualization', // This is required if you use the Autocomplete plugin  // ,drawing,visualization
		// OR: libraries: 'places,drawing'
		// OR: libraries: 'places,drawing,visualization'
		// (as you require)

		//// If you want to set the version, you can do so:
		// v: '3.26',
	},
	//// If you intend to programmatically custom event listener code
	//// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
	//// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
	//// you might need to turn this on.
	// autobindAllEvents: false,

	//// If you want to manually install components, e.g.
	//// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
	//// Vue.component('GmapMarker', GmapMarker)
	//// then disable the following:
	// installComponents: true,
})


Vue.prototype.$map = null;
Vue.prototype.$mapPlacesService = null;
Vue.prototype.$mapRef = null;
Vue.prototype.$mapShown = 0;
Vue.prototype.$mapShownFullScreen = 0;

Vue.loadScript("/js/geoxml3.js", "geoXML3").then(() => {
		Vue.prototype.$geoXML3 = geoXML3;

	})
	.catch(() => {});


import VueTooltip from 'v-tooltip'
Vue.use(VueTooltip);
VueTooltip.options.defaultTemplate = '<div class="App__tooltip-vue" role="App__tooltip"><div class="App__tooltip-vue-arrow"></div><div class="App__tooltip-vue-inner"></div></div>';
VueTooltip.options.defaultArrowSelector = '.App__tooltip-vue-arrow, .App__tooltip-vue__arrow';
VueTooltip.options.defaultInnerSelector = '.App__tooltip-vue-inner, .App__tooltip-vue__inner';
VueTooltip.options.defaultTrigger = window.innerWidth > 768 ? 'hover click' : 'click';


import axios from 'axios'

// var instance = axios.create();



// // Include the Authentication header when using JWT authentication
// axios.interceptors.request.use(request => {
//   token = localStorage.getItem('token');
//   if (token) {
//     request.headers['Authorization'] = 'Bearer ' + store.state.context.jwtToken
//   } else {
//   }

//   // if (store.state.context.jwtToken) request.headers['Authorization'] = 'Bearer ' + store.state.context.jwtToken
//   return request
// })

// Setup axios as the Vue default $http library
Vue.prototype.$http = axios.create();
Vue.prototype.$http.defaults.baseURL = process.env.VUE_APP_API_URL // same as the Url the server listens to
Vue.prototype.$http.defaults.withCredentials = true

axios.defaults.headers.common['App-Build'] = process.env.VUE_APP_BUILD_VERSION;
Vue.prototype.$http.defaults.headers.common['App-Build'] = process.env.VUE_APP_BUILD_VERSION;

axios.defaults.headers.common['App-Platform'] = process.env.VUE_APP_PLATFORM;
Vue.prototype.$http.defaults.headers.common['App-Platform'] = process.env.VUE_APP_PLATFORM;

axios.defaults.headers.common['App-Id'] = process.env.VUE_APP_ID;
Vue.prototype.$http.defaults.headers.common['App-Id'] = process.env.VUE_APP_ID;

Vue.prototype.$http.interceptors.response.use(
	function(res) {
		return res;
	},
	function (error) {
		if (!store.getters.isLoggedIn) {
			if (typeof error != "undefined") {
				return Promise.reject(error);
			} else {
				return Promise.reject();
		}
		}
		if (error) {
			if (error.response ) {
				if (error.response.status == 400) {
					if (error.response.data.error.code == 'error.api.noPermission') {
						if (error.response.data.fields.User == 'User is not approved or active.') {
					Vue.prototype.$bus.$emit("app:showLoginExpireDialog");
				}
			}
		}
				if (error.response.status == 401) {
			Vue.prototype.$bus.$emit("app:showLoginExpireDialog");
		}
		}
			if (typeof error != "undefined") {
				return Promise.reject(error);
			} else {
				return Promise.reject();
			}
		}
	});

const token = localStorage.getItem('token')
if (token) {
	// TODO: validate the token.
	Vue.prototype.$http.defaults.headers.common['Authorization'] = "Bearer " + token
} else {
	Vue.prototype.$http.defaults.headers.common['Authorization'] = ""
}

Vue.prototype.$httpNoCORS = axios.create();
Vue.prototype.$httpNoCORS.withCredentials = false;
Vue.prototype.$httpNoCORS.baseURL = "";
delete Vue.prototype.$httpNoCORS.defaults.headers.common['Authorization'];
delete Vue.prototype.$httpNoCORS.defaults.headers.common['App-Build'];
delete Vue.prototype.$httpNoCORS.defaults.headers.common['App-Id'];
delete Vue.prototype.$httpNoCORS.defaults.headers.common['App-Platform'];


import Vue2Filters from 'vue2-filters';
Vue.use(Vue2Filters);
Vue.use(require('vue-moment'));
// Vue.use(require('moment-timezone'));
import moment from 'moment';

moment.relativeTimeThreshold('s', 59);
moment.relativeTimeThreshold('m', 59);
moment.relativeTimeThreshold('h', 23);


Vue.prototype.moment = moment;
import VueI18n from 'vue-i18n';
import messages from './translations/common.js';

Vue.use(VueI18n);
if (localStorage.locale != "en-CA" && localStorage.locale != "fr-CA") {
	localStorage.locale = "en-CA";
}
const i18n = new VueI18n({
	locale: localStorage.locale || 'en-CA',
	fallbackLocale: 'en-CA',
	fallbackRoot: true,
	silentTranslationWarn: true,
	messages
});

import Vuex from 'vuex';
Vue.use(Vuex);

import Numeral from 'numeral';
Numeral.locale('en');
Numeral.defaultFormat('$0,0.00');
// Numeral.nullFormat('NULL');
// Numeral.zeroFormat('ZERO');
Vue.use(Numeral);

// Sets focus on an element when it gets inserted into the DOM.
Vue.directive('focus', {
	inserted(el) {
		el.focus();
	}
});


Vue.directive('uppercase', {
	update(el) {
		el.value = el.value.toUpperCase()
	},
})



import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './scss/main.scss'
import './fonts/source-sans-pro/source-sans-pro.css'
import './fonts/source-sans-variable/source-sans-variable.css'
import './fonts/feather-icomoon/style.css'
Vue.use(BootstrapVue)


import Photoswipe from 'vue-pswipe'
Vue.use(Photoswipe, {})


// Font Awesome
import {
	library
} from '@fortawesome/fontawesome-svg-core'
import {
	faEdit
} from '@fortawesome/free-solid-svg-icons'
import {
	faFileImage
} from '@fortawesome/free-regular-svg-icons'
import {
	faFile
} from '@fortawesome/free-regular-svg-icons'
import {
	faFileExcel
} from '@fortawesome/free-regular-svg-icons'
import {
	faFilePdf
} from '@fortawesome/free-regular-svg-icons'
import {
	faFilePowerpoint
} from '@fortawesome/free-regular-svg-icons'
import {
	faFileWord
} from '@fortawesome/free-regular-svg-icons'
import {
	faFileVideo
} from '@fortawesome/free-regular-svg-icons'
import {
	faUser
} from '@fortawesome/free-regular-svg-icons'
import {
	faUsers
} from '@fortawesome/free-solid-svg-icons'
import {
	faChevronDown
} from '@fortawesome/free-solid-svg-icons'
import {
	faPaperPlane
} from '@fortawesome/free-solid-svg-icons'
import {
	faChevronRight
} from '@fortawesome/free-solid-svg-icons'
import {
	faChevronLeft
} from '@fortawesome/free-solid-svg-icons'
import {
	faUserPlus
} from '@fortawesome/free-solid-svg-icons'
import {
	faTrash
} from '@fortawesome/free-solid-svg-icons'
import {
	faWindowClose
} from '@fortawesome/free-solid-svg-icons'
import {
	faPlusCircle
} from '@fortawesome/free-solid-svg-icons'
import {
	faMinusCircle
} from '@fortawesome/free-solid-svg-icons'
import {
	faPrint
} from '@fortawesome/free-solid-svg-icons'
import {
	faBell
} from '@fortawesome/free-regular-svg-icons'
import {
	faExclamationTriangle
} from '@fortawesome/free-solid-svg-icons'
import {
	FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'

library.add(faEdit, faFileImage, faFile, faFileExcel, faFilePdf, faFilePowerpoint, faFileWord, faFileVideo, faUser, faUserPlus, faUsers, faChevronDown, faChevronRight, faChevronLeft, faTrash, faWindowClose, faPlusCircle, faMinusCircle, faPrint, faBell, faPaperPlane, faExclamationTriangle)
Vue.component('font-awesome-icon', FontAwesomeIcon)


Vue.config.productionTip = false



import { routerHistory, writeHistory } from 'vue-router-back-button'
Vue.use(routerHistory)

router.afterEach(writeHistory);


if (window.screen.orientation) {
	try {
		window.screen.orientation.lock('portrait');
	} catch(e) {
		console.log("locking of portrait mode not supported.");
	}
}

/**
 * Do not throw an exception if push is rejected by redirection from navigation guard
 */
// const originalPush = router.push;
// router.push = function push(location, onResolve, onReject) {
// 	if (onResolve || onReject) {
// 		return originalPush.call(this, location, onResolve, onReject);
// 	}
// 	return originalPush.call(this, location).catch((err) => {
// 		let reg = new RegExp('^Redirected when going from "[a-z_.\\/]+" to "[a-z_.\\/]+" via a navigation guard.$');
// 		if (reg.test(err.message)) {
// 			// If pushing interrupted because of redirection from navigation guard - ignore it.
// 			return Promise.resolve(false);
// 		}
// 		// Otherwise throw error
// 		return Promise.reject(err);
// 	});
// };

router.afterEach((to, from, next) => {
	if (to != null) {

		if (document.getElementById("statusBarCover")) {
			if ((to.name === 'ReportContravention' || to.name === 'ReportClosure' || to.name === 'ReportRestriction' || to.name === 'EditLaneClosureRequest' || to.name === 'LaneClosureRequestActivity' || to.name === 'LaneClosureRequestContraventions' || to.name === 'LaneClosureRequestAttachments' || to.name === 'ViewLaneClosureRequest' || to.name === 'EditContravention')) {
				document.getElementById("statusBarCover").classList.add("showingViewRequestMenu");
			} else {
				document.getElementById("statusBarCover").classList.remove("showingViewRequestMenu");
			}
		}
	}
});

import {clearAllBodyScrollLocks} from 'body-scroll-lock';


router.beforeEach((to, from, next) => {
	// redirect to login page if not logged in and trying to access a restricted page
	let publicPages = ['/login', '/register', '/forgot-password', '/reset-password', '/register-organization', '/register-user', '/confirm-organization-registration', '/confirm-user-registration', '/create-account', '/register-access-code'];
	let authRequired = !publicPages.includes(to.path);
	if (to.path.indexOf("/confirm-organization-registration") == 0) {
		authRequired = false;
	}
	if (to.path.indexOf("/approve-organization-registration") == 0) {
		authRequired = false;
	}
	if (to.path.indexOf("/register/") == 0) {
		authRequired = false;
	}
	if (to.path.indexOf("/reject-organization-registration") == 0) {
		authRequired = false;
	}
	if (to.path.indexOf("/confirm-user-registration") == 0) {
		authRequired = false;
	}
	if (to.path.indexOf("/approve-user-registration") == 0) {
		authRequired = false;
	}
	if (to.path.indexOf("/reject-user-registration") == 0) {
		authRequired = false;
	}

	if (to.path.indexOf("/create-account") == 0) {
		authRequired = false;
	}
	if (to.path.indexOf("/reset-password") == 0) {
		authRequired = false;
	}

	// Unlock scrolling
	clearAllBodyScrollLocks();

	let loggedIn = store.getters.isLoggedIn;
	let tokenValid = store.getters.tokenValid();
	let logoutRequested = store.getters.logoutRequested;
	if (!tokenValid || logoutRequested) {
		loggedIn = false;
		store.dispatch('logout');
	}
	if (authRequired && !loggedIn) {
		if (to.path.indexOf("/login") == -1) {
			// return next({
			// 	path: '/login',
			// 	query: {
			// 		from: to.path
			// 	}
			// });
			Vue.nextTick(vm => {
					if (Vue.prototype.$store.getters.userInfo()) {
						Vue.prototype.$bus.$emit("app:showLoginExpireDialog");
					}
				})
				// return next();
			return next({
				name: 'login',
				query: {
					redirect: to.fullPath
				}
			});
		} else {
			return next('/login');
		}
	} else {
		if (localStorage.getItem("deviceId") != "") {
			Vue.prototype.$bus.$emit("app:registerDevice", 0);
		}

		Vue.prototype.$bus.$emit("menu:toggle", 0);
		next();
	}
});



// allow for duplicationErrorPushing, so we can click the links in the mobile navigation while already on the request list page and not have it fail.
router.duplicationErroringPush = router.push;
const originalPush = router.push;
router.push = async function(location) {
	try {
		console.log("location", location);

		try{
			var foo = router.duplicationErroringPush(location);
			console.log("foo",foo);

		} catch(error) {
			console.log("hmmm", error);
			if (error) {
				if (error.name) {
					if (error.name === 'NavigationDuplicated') {
						return this.currentRoute;
					}
				}
				// Also need to check this message, becuase the error.name is just "Error"
				if (error.message) {
					if (error.message.indexOf("Avoided redundant navigation to current location") == 0) {
						return this.currentRoute;
					}
				}
			}

		}
		// return router.duplicationErroringPush(this, location).catch((error) => {
		// 	console.log("hmmm", error);
		// 	if (error) {
		// 		if (error.name) {
		// 			if (error.name === 'NavigationDuplicated') {
		// 				return this.currentRoute;
		// 			}
		// 		}
		// 		// Also need to check this message, becuase the error.name is just "Error"
		// 		if (error.message) {
		// 			if (error.message.indexOf("Avoided redundant navigation to current location") == 0) {
		// 				return this.currentRoute;
		// 			}
		// 		}
		// 	}

			// TODO: is there an issue with not throwing an error?  I commented it out to avoid console errors in the browser.
			// console.log(error);
			// throw error;
		// });
	} catch(e) {
		console.log("router push try failed", e);
	}

};





Vue.prototype.$scrollTop = function() {
	var element = document.getElementById("main");
	var top = element.offsetTop;
	window.scrollTo(0, top);
}



/*
function getAuthToken () {
  // if the current store token expires soon
    if (jwt(store.getters['auth/token']).exp - 240 <= (Date.now() / 1000).toFixed(0)) {
    // if not already requesting a token
    if (authTokenRequest === null) {
      authTokenRequest = axios.post('/auth/refresh', {}, { withCredentials: true })
          .then(response => {
          // request complete and store
          resetAuthTokenRequest()
          store.commit('auth/refresh', response.daa.access_token)
          return response.data.access_token
          })
      }
     return authTokenRequest
    }
    return store.getters['auth/token']
}

// tokenRequest dirty bit reseter
function resetAuthTokenRequest () {
  authTokenRequest = null
}

// Axios Intercept Requests
axios.interceptors.request.use(async function (config) {
  // If not one of these specific pages that doesn't need a token, use method to get the current token or request a new one.  Otherwise, use current token (possibly none)
  if (!config.url.includes('login') && !config.url.includes('refresh') && !config.url.includes('forgot_password') && !config.url.includes('reset_password') && !config.url.includes('activate')) {
    config.headers['Authorization'] = 'Bearer ' + await getAuthToken()
  } else {
    config.headers['Authorization'] = 'Bearer ' + store.getters['auth/token']
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

axios.interceptors.response.use(function (config) {
  return config
}, function (error) {
  // Prevent endless redirects (login is where you should end up)
  if (error.request !== undefined) {
    if (error.request.responseURL.includes('login')) {
      return Promise.reject(error)
    }
  }

  // If you can't refresh your token or you are sent Unauthorized on any request, logout and go to login
  if (error.request !== undefined && (error.request.responseURL.includes('refresh') || error.request.status === 401 && error.config.__isRetryRequest)) {
    store.dispatch('auth/logout')
    router.push({name: 'Login'})
  } else if (error.request !== undefined && error.request.status === 401) {
    error.config.__isRetryRequest = true
    return axios.request(error.config)
  }
  return Promise.reject(error)
})
*/
export const EventBus = new Vue();
import store from './store'


const routerStore = new Vuex.Store({
	state: {
		routerHistory: [],
	},
	getters: {
		currentRoute: (state) => {
			const historyLenCurrent = state.routerHistory.length;
			if (historyLenCurrent == 0) return null;
			return state.routerHistory[historyLenCurrent];
		},
		previousRoute: (state) => {
			const historyLenPrevious = state.routerHistory.length;
			if (historyLenPrevious == 0) return null;
			return state.routerHistory[historyLenPrevious - 1];
		},
		getLastListPage: (state) => {
			const historyLen = state.routerHistory.length;
			if (historyLen == 0) return null;
			let x = 0;
			for (x = historyLen - 1; x >= 0; x--) {
				if (
					state.routerHistory[x].name == "AuditLogList" ||
					state.routerHistory[x].name == "ContraventionList" ||
					state.routerHistory[x].name == "LaneClosureList" ||
					state.routerHistory[x].name == "OrganizationList" ||
					state.routerHistory[x].name == "OrganizationRequestList" ||
					state.routerHistory[x].name == "AppUserRequestList" ||
					state.routerHistory[x].name == "ReportClosureSearch" ||
					state.routerHistory[x].name == "ReportContraventionSearch" ||
					state.routerHistory[x].name == "ReportRestrictionSearch" ||
					state.routerHistory[x].name == "UserApprovalList" ||
					state.routerHistory[x].name == "UserList"
				) {
					break;

				}
			}
			if (x >= 0) {
				return state.routerHistory[x];
			} else {
				return null;
			}

			return state.routerHistory[historyLen - 1];
		},
		getLastListPageOrViewRequest: (state) => {
			const historyLen = state.routerHistory.length;
			if (historyLen == 0) return null;
			let x = 0;
			for (x = historyLen - 1; x >= 0; x--) {
				if (
					state.routerHistory[x].name == "ViewLaneClosureRequest" ||
					state.routerHistory[x].name == "ViewLaneClosureRequestScrollTo" ||
					state.routerHistory[x].name == "AuditLogList" ||
					state.routerHistory[x].name == "ContraventionList" ||
					state.routerHistory[x].name == "LaneClosureList" ||
					state.routerHistory[x].name == "OrganizationList" ||
					state.routerHistory[x].name == "OrganizationRequestList" ||
					state.routerHistory[x].name == "AppUserRequestList" ||
					state.routerHistory[x].name == "ReportClosureSearch" ||
					state.routerHistory[x].name == "ReportContraventionSearch" ||
					state.routerHistory[x].name == "ReportRestrictionSearch" ||
					state.routerHistory[x].name == "UserApprovalList" ||
					state.routerHistory[x].name == "UserList"
				) {
					if (state.routerHistory[x].name != state.routerHistory[historyLen - 1].name) {
						break;
					}
				}
			}
			if (x >= 0) {
				return state.routerHistory[x];
			} else {
				return null;
			}

			return state.routerHistory[historyLen - 1];
		},

		getLastListPageOrViewRequestViolations: (state) => {
			const historyLen = state.routerHistory.length;
			if (historyLen == 0) return null;
			let x = 0;
			for (x = historyLen - 1; x >= 0; x--) {
				if (
					state.routerHistory[x].name == "LaneClosureRequestContraventions" ||
					state.routerHistory[x].name == "ViewLaneClosureRequest" ||
					state.routerHistory[x].name == "ViewLaneClosureRequestScrollTo" ||
					state.routerHistory[x].name == "AuditLogList" ||
					state.routerHistory[x].name == "ContraventionList" ||
					state.routerHistory[x].name == "LaneClosureList" ||
					state.routerHistory[x].name == "OrganizationList" ||
					state.routerHistory[x].name == "OrganizationRequestList" ||
					state.routerHistory[x].name == "AppUserRequestList" ||
					state.routerHistory[x].name == "ReportClosureSearch" ||
					state.routerHistory[x].name == "ReportContraventionSearch" ||
					state.routerHistory[x].name == "ReportRestrictionSearch" ||
					state.routerHistory[x].name == "UserApprovalList" ||
					state.routerHistory[x].name == "UserList"
				) {
					break;

				}
			}
			if (x >= 0) {
				return state.routerHistory[x];
			} else {
				return null;
			}

			return state.routerHistory[historyLen - 1];
		},


	},
});
Vue.prototype.$routerStore = routerStore;

import router from './router'
Vue.prototype.$store = store;
Vue.prototype.$bus = new Vue();


import LaneClosureRequestHub from './utility/LaneClosureRequestHub';
Vue.use(LaneClosureRequestHub);

import DocumentTitle from './utility/DocumentTitle';
Vue.mixin(DocumentTitle);

var platformId = Capacitor.getPlatform();
if (platformId) {
	document.body.classList.add('is-' + platformId);
}


export const app = new Vue({
	i18n,
	router,
	store,
	platformId,
	render: h => h(App),
})

import {
	Keyboard
} from '@capacitor/keyboard';

if (Keyboard) {
	Keyboard.setAccessoryBarVisible({
		isVisible: true
	});

	Keyboard.setResizeMode({
		mode: "none"
	});

	Keyboard.addListener('keyboardWillShow', info => {
		Vue.prototype.$bus.$emit('keyboard:willShow');
		Vue.prototype.$store.commit('setKeyboardWillShow', true);
		Vue.prototype.$store.commit('setKeyboardHeight', info.keyboardHeight);
	});

	Keyboard.addListener('keyboardDidShow', info => {
		Vue.prototype.$bus.$emit('keyboard:didShow');
		Vue.prototype.$store.commit('setKeyboardVisible', true);
		Vue.prototype.$store.commit('setKeyboardWillShow', false);
		document.activeElement.parentElement.scrollIntoView({
			block: 'center',
			behavior: 'smooth'
		});
		/*
				document.activeElement.scrollIntoView({
					behavior: 'smooth',
					block: 'end'
				});
			*/
		/*
		let elementFocused = document.querySelector(':focus');
		if (elementFocused) {
			console.log(elementFocused);
		}
		*/
	});

	Keyboard.addListener('keyboardWillHide', () => {
		Vue.prototype.$bus.$emit('keyboard:willHide');
		window.scrollTo(0, 0);
		document.body.scrollTop = 0;
	});

	Keyboard.addListener('keyboardDidHide', () => {
		Vue.prototype.$bus.$emit('keyboard:didHide');
		Vue.prototype.$store.commit('setKeyboardVisible', false);
	});


}


app.$mount('#app');

var $ = window.jQuery = require('jquery')
require('./jquery.tabbable');

$(document).on('keydown', '.multiselect', function(event) {
	if (event.which === 9) {
		if (event.shiftKey) {
			jQuery.tabPrev();
		} else {
			jQuery.tabNext();
		}
		var e = $.Event('click');
		$(event.target).parent().siblings().find('.multiselect__option--highlight:not(.multiselect__option--selected)').trigger(e);
		event.preventDefault();
	}

});
import VueSmoothScroll from 'vue2-smooth-scroll'
Vue.use(VueSmoothScroll, {
  duration: 400,
  updateHistory: false,
})




import EdgeCheck from 'vue-edge-check'
Vue.use(EdgeCheck)

import Vue2TouchEvents from 'vue2-touch-events';
Vue.use(Vue2TouchEvents);
window.addEventListener('resize', function() {
	setTimeout(() => {
		if (window.innerWidth <= 992) {
			store.state.isMobile = true;
			document.body.classList.add('mobile-body');
		} else {
			store.state.isMobile = false;
			document.body.classList.remove('mobile-body');
		}
	}, 100);
});
window.dispatchEvent(new Event('resize'));

window.addEventListener('keydown', function(event) {
	if (event.defaultPrevented) {
		return; // Should do nothing if the default action has been cancelled
	}
	let handled = false;
	if (event.keyCode == 121) {
		handled = true;
		debugger; // 123 is the keyCode of F12
	}
	if (handled) {
		// Suppress "double action" if event handled
		event.preventDefault();
	}
});


window.addEventListener('focus', function(event) {
			console.log(event);
		// Vue.prototype.$store.commit('setKeyboardVisible', true);

});




